import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-market-conditions',
  templateUrl: './market-conditions.component.html',
  styleUrls: ['./market-conditions.component.scss']
})

export class MarketConditionsComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  valueDropdown = [
    {
      id: 1,
      value: 'สรุปภาวะตลาด'
    },
    {
      id: 2,
      value: 'Newsletter'
    },
    {
      id: 3,
      value: 'VDO Clip'
    },
    {
      id: 4,
      value: 'กองทุนแนะนำ'
    }
  ];
  constructor() { }

  ngOnInit() {
  }

}
